import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { showErrorMessage } from '@/shared/adapters/toast';
import { APP_ROUTES } from '@/app/routePaths';
import { resolveMailchimpCompanyId } from '../utils/mailchimpCompanyId';

const MailchimpCallback = () => {
  const navigate = useNavigate();
  const channelsRoute = APP_ROUTES.CHANNELS;

  useEffect(() => {
    const alreadyProcessed = sessionStorage.getItem('mailchimp_callback_processed') === 'true';
    if (alreadyProcessed) return;

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('mailchimp_token');
    const server = urlParams.get('mailchimp_server');
    const accountName = urlParams.get('mailchimp_account_name');
    const listsParam = urlParams.get('mailchimp_lists');
    const errorParam = urlParams.get('mailchimp_error');

    if (errorParam) {
      showErrorMessage('Mailchimp connection failed: ' + decodeURIComponent(errorParam));
      navigate(channelsRoute);
      return;
    }

    if (token && server && listsParam) {
      sessionStorage.setItem('mailchimp_callback_processed', 'true');
      sessionStorage.setItem('mailchimp_auth_token', token);
      sessionStorage.setItem('mailchimp_auth_server', server);
      sessionStorage.setItem('mailchimp_auth_account_name', accountName || '');
      sessionStorage.setItem('mailchimp_auth_lists', listsParam);
      sessionStorage.setItem('mailchimp_auth_pending', 'true');

      setTimeout(() => {
        sessionStorage.removeItem('mailchimp_callback_processed');
      }, 1000);

      const returnUrl = sessionStorage.getItem('mailchimp_auth_return_url');
      sessionStorage.removeItem('mailchimp_auth_return_url');

      const existingFlow = sessionStorage.getItem('mailchimp_auth_flow');
      if (!existingFlow) {
        const resolvedCompanyId = resolveMailchimpCompanyId({ returnUrl });
        if (resolvedCompanyId > 0) {
          sessionStorage.setItem('mailchimp_auth_flow', JSON.stringify({ companyId: resolvedCompanyId }));
          localStorage.setItem('selectedCompanyId', String(resolvedCompanyId));
        }
      }

      if (returnUrl) {
        navigate(returnUrl);
      } else {
        navigate(channelsRoute);
      }
      return;
    }

    if (window.location.search) {
      showErrorMessage('Invalid Mailchimp callback parameters');
      navigate(channelsRoute);
      return;
    }

    navigate(channelsRoute);
  }, [navigate, channelsRoute]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
      }}
    >
      <div className="spinner" style={{ fontSize: '48px' }}>
        <i className="bx bx-loader-alt bx-spin"></i>
      </div>
      <p style={{ marginTop: '20px' }}>Processing Mailchimp connection...</p>
    </div>
  );
};

export default MailchimpCallback;
